export default __webpack_public_path__ + "static/media/Fly.1e23f915.png";